import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./app";

// Render the app
// biome-ignore lint/style/noNonNullAssertion:
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
